<template>
    <van-popup class="web-login-popup" :value="showWebLoginCode" @click-overlay="clickCancel">
        <div class="web-login-step-2">
            <div class="web-login-title">App扫码登录</div>
            <div class="web-login-wechat-code">
                <qrcode id='qrImg' tag="img" :options="{size: 200, padding: 20}" :value="loginCode" ></qrcode>
            </div>
            <div class="web-login-sub-title">请使用天时子平八字App扫描二维码登录</div>
        </div>
    </van-popup>
</template>

<script>
import { UTILS, COOKIE } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
export default {
    name: 'WebLoginPop',
    computed: {
        showWebLoginCode() {
            return this.$store.state.weblogin.showWebLoginCode
        }
    },
    watch: {
        showWebLoginCode(value) {
            if(value) {
                this.loginCode = this.generateLoginCode();
                this.startPollingLogin();
            }else {
                this.stopPollingLogin();
            }
        }
    },
    data() {
        return {
            CONFIG: CONFIG,
            loginCode: '',
            loginPollingTimer: null,
            loginRequesting: false,
            loginType: 1,
            telNumValue: '',
            passWordValue: '',
            verifyLocked: true,
            agreed: true,
        }
    },
    methods: {
        generateLoginCode() {
            var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-',
                code = 'login_';
            for(var index = 0; index < 16; index++) {
                code += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return code;
        },
        startPollingLogin() {
            this.stopPollingLogin();
            this.pollLoginStatus();
            this.loginPollingTimer = setInterval(() => {
                this.pollLoginStatus();
            }, 3000);
        },
        stopPollingLogin() {
            if(this.loginPollingTimer) {
                clearInterval(this.loginPollingTimer);
                this.loginPollingTimer = null;
            }
            this.loginRequesting = false;
        },
        pollLoginStatus() {
            if(this.loginRequesting || !this.loginCode || !this.showWebLoginCode) {
                return;
            }
            this.loginRequesting = true;
            this.$store.dispatch('weblogin/getCodeLogin', {
                code: this.loginCode,
                sucCb: (data) => {
                    this.loginRequesting = false;
                    this.stopPollingLogin();
                    this.$store.state.weblogin.showWebLoginCode = false;
                    this.$store.state.weblogin.showWebLogin = false;
                    this.$store.state.userData = data;
                    this.$toast("登录成功");
                    COOKIE.setCookie('fatetoken', data.token, 5);
                    window.sessionStorage.setItem('H5_Fate_UserInfo', JSON.stringify(data));
                },
                failCb: () => {
                    this.loginRequesting = false;
                }
            });
        },
        clickCancel() {
            this.$store.state.weblogin.showWebLoginCode = false;
        },
        clickToggle() {
            this.loginType = this.loginType == 1 ? 2 : 1;
            this.checkVerifyLocked();
        },
        checkVerifyLocked() {
            if(this.loginType == 2 && this.telNumValue != '') {
                this.verifyLocked = !UTILS.isPoneAvailable(parseInt(this.telNumValue));
            }
        },
        clickGetCode() {
            // 获取二维码按钮被锁定
            if(this.verifyLocked) {
                return;
            }
            var me = this;
            this.$store.dispatch('weblogin/getLoginCode', {
                tel: this.telNumValue,
                type: '1',
                sucCb: function() {
                    me.verifyLocked = true;
                    setTimeout(() => {
                        me.verifyLocked = false;
                    }, 60000);
                }
            })
        },
        clickLogin() {
            // 检验数据是否为空
            if(this.telNumValue == '') {
                this.$toast('请输入手机号码');
                return;
            }
            if(this.passWordValue == '') {
                if(this.loginType == 1) {
                    this.$toast('请输入密码');
                }else {
                    this.$toast('请输入验证码');
                }
                return;
            }
            if(!this.agreed) {
                this.$toast('请先同意服务协议和隐私政策');
                return;
            }
            // 校验数据准确性
            if(!UTILS.isPoneAvailable(parseInt(this.telNumValue))) {
                this.$toast('请输入正确的手机号码');
                return;
            }
            console.log('clickLogin--------', this.telNumValue, this.passWordValue, this.loginType)

            this.$store.dispatch('weblogin/getUserLogin', {
                tel: this.telNumValue,
                password: this.passWordValue,
                type: this.loginType.toString()
            });
        },
        clickWechat() {
            // this.$store.state.weblogin.showWebLoginWechatCode = true; 
            window.location.href = CONFIG.getWechatAuthUrl();
        },
        clickQQ() {
            window.location.href = CONFIG.getQQAuthUrl();
        },
        clickApp() {
            // login
        },
        clickAgree() {
            this.agreed = !this.agreed;
        },
        clickAgreeUrl() {
            window.open(CONFIG.agree_url);
        },
        clickPrivacyUrl() {
            window.open(CONFIG.privacy_url);
        },
        clickBack() {
            this.$store.state.weblogin.showWebLoginWechatCode = false; 
        }
    },
    beforeDestroy() {
        this.stopPollingLogin();
    }
}
</script>